export const AMENITY_STATUS_OPTIONS = [
  {
    label: 'Upcoming',
    value: 'upcoming',
  },
  {
    label: 'Past',
    value: 'past',
  },
];

export const RESERVATION_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'denied', label: 'Denied' },
  { value: 'canceled', label: 'Canceled' }, // TODO: review 'canceled vs cancelled' (see const below)
  { value: 'success', label: 'Success' },
];

export const AMENITY_MULTI_STATUS_OPTIONS = [
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Denied',
    value: 'denied',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
];

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// regex for hh:mm:ss or h:mm:ss
export const TIME_REGEX = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/;
